module.exports = __webpack_public_path__ + "media/thumbnails/shoe-style-1-8485cc80.svg";